import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

export const ChangeBordingLozenge = () => {
	const { formatMessage } = useIntl();
	return <Lozenge appearance="new">{formatMessage(messages.changeBoardingLozengeLabel)}</Lozenge>;
};
